import React, { useEffect, useState, useCallback } from "react";
import "../styles/AdminMatrimonial.css";
import "../styles/AdminVivahaprapthi.css";
import { SITE_SETTINGS_API, VEDAPATSHALA_ENQUIRY_API, GURUKULAM_ADMISSIONS_API, VIVAHAPRAPTHI_API, API_BASE, getImageUrl } from "../config/api";
import { showConfirm, showPrompt } from "../utils/customDialog";

function AdminForms() {
  const [activeTab, setActiveTab] = useState("vivahaprapthi"); // "vivahaprapthi" | "vedapatshala" | "settings"
  const [vivahaprapthiList, setVivahaprapthiList] = useState([]);
  const [vivahaprapthiFilter, setVivahaprapthiFilter] = useState("All");
  const [selectedVivahReg, setSelectedVivahReg] = useState(null);
  const [vedapatshalaEntries, setVedapatshalaEntries] = useState([]);
  const [gurukulamAdmissions, setGurukulamAdmissions] = useState([]);
  const [googleFormUrl, setGoogleFormUrl] = useState("");
  const [googleGurukulamFormUrl, setGoogleGurukulamFormUrl] = useState("");
  const [showRazorpaySecret, setShowRazorpaySecret] = useState(false);
  const [paymentSettings, setPaymentSettings] = useState({
    vaithikasri_admin_email: "sharikarajan12a@gmail.com",
    gurukulam_admin_email: "sharikarajan12a@gmail.com",
    admin_notification_email: "sharikarajan12a@gmail.com",
    upi_id: "7598856176@okbizaxis",
    upi_phone: "75988 56176",
    upi_payee_name: "Vaithikasri Publications LLP",
    bank_account_name: "Vaithikasri Publications LLP",
    bank_name: "State Bank of India (Current Account)",
    bank_account_number: "33940661503",
    bank_ifsc: "SBIN0040203",
    bank_branch: "Abhiramapuram, Chennai",
    razorpay_key_id: "rzp_test_ShbhxojUw282FB",
    razorpay_key_secret: "BEMkjLfjQ4hGlv4LYpR2sQx3",
    razorpay_mode: "test"
  });
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [savingSettings, setSavingSettings] = useState(false);

  // 1. Vaithikasri Admin Email Management States
  const [newVaithikasriEmailInput, setNewVaithikasriEmailInput] = useState("");
  const [editingVaithikasriEmailIndex, setEditingVaithikasriEmailIndex] = useState(null);
  const [editingVaithikasriEmailValue, setEditingVaithikasriEmailValue] = useState("");

  const getVaithikasriEmailList = () => {
    const raw = paymentSettings.vaithikasri_admin_email || paymentSettings.admin_notification_email || "";
    return raw
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  };

  const persistVaithikasriEmailList = async (updatedList) => {
    const updatedEmailString = updatedList.join(", ");
    setPaymentSettings((prev) => ({
      ...prev,
      vaithikasri_admin_email: updatedEmailString,
      admin_notification_email: updatedEmailString
    }));
    try {
      const res = await fetch(SITE_SETTINGS_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          vaithikasri_admin_email: updatedEmailString,
          admin_notification_email: updatedEmailString
        }),
      });
      const data = await res.json();
      return data?.status === "success";
    } catch (err) {
      console.error("Auto-save Vaithikasri email error:", err);
      return false;
    }
  };

  const handleAddVaithikasriEmail = async (e) => {
    if (e) e.preventDefault();
    const email = newVaithikasriEmailInput.trim();
    if (!email) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Please enter a valid email address!`);
      return;
    }
    const currentList = getVaithikasriEmailList();
    if (currentList.includes(email)) {
      showPopup(`<i class="bi bi-info-circle-fill" style="margin-right: 8px; color: #3498db;"></i> This email is already added.`);
      return;
    }
    const newList = [...currentList, email];
    setNewVaithikasriEmailInput("");
    const success = await persistVaithikasriEmailList(newList);
    if (success) {
      showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Added Vaithikasri email recipient: ${email}`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to save email to server.`);
    }
  };

  const handleDeleteVaithikasriEmail = async (indexToDelete) => {
    const currentList = getVaithikasriEmailList();
    const newList = currentList.filter((_, idx) => idx !== indexToDelete);
    const success = await persistVaithikasriEmailList(newList);
    if (success) {
      showPopup(`<i class="bi bi-trash-fill" style="margin-right: 8px; color: #e74c3c;"></i> Vaithikasri email recipient removed.`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to remove email on server.`);
    }
  };

  const handleStartEditVaithikasriEmail = (index, currentEmail) => {
    setEditingVaithikasriEmailIndex(index);
    setEditingVaithikasriEmailValue(currentEmail);
  };

  const handleSaveEditedVaithikasriEmail = async (indexToSave) => {
    const email = editingVaithikasriEmailValue.trim();
    if (!email) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Please enter a valid email address!`);
      return;
    }
    const currentList = getVaithikasriEmailList();
    currentList[indexToSave] = email;
    setEditingVaithikasriEmailIndex(null);
    setEditingVaithikasriEmailValue("");
    const success = await persistVaithikasriEmailList(currentList);
    if (success) {
      showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Vaithikasri email recipient updated!`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to save updated email.`);
    }
  };

  // 2. Sri Seetharama Gurukulam Trust Email Management States
  const [newGurukulamEmailInput, setNewGurukulamEmailInput] = useState("");
  const [editingGurukulamEmailIndex, setEditingGurukulamEmailIndex] = useState(null);
  const [editingGurukulamEmailValue, setEditingGurukulamEmailValue] = useState("");

  const getGurukulamEmailList = () => {
    const raw = paymentSettings.gurukulam_admin_email || "";
    return raw
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  };

  const persistGurukulamEmailList = async (updatedList) => {
    const updatedEmailString = updatedList.join(", ");
    setPaymentSettings((prev) => ({
      ...prev,
      gurukulam_admin_email: updatedEmailString
    }));
    try {
      const res = await fetch(SITE_SETTINGS_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gurukulam_admin_email: updatedEmailString
        }),
      });
      const data = await res.json();
      return data?.status === "success";
    } catch (err) {
      console.error("Auto-save Gurukulam email error:", err);
      return false;
    }
  };

  const handleAddGurukulamEmail = async (e) => {
    if (e) e.preventDefault();
    const email = newGurukulamEmailInput.trim();
    if (!email) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Please enter a valid email address!`);
      return;
    }
    const currentList = getGurukulamEmailList();
    if (currentList.includes(email)) {
      showPopup(`<i class="bi bi-info-circle-fill" style="margin-right: 8px; color: #3498db;"></i> This email is already added.`);
      return;
    }
    const newList = [...currentList, email];
    setNewGurukulamEmailInput("");
    const success = await persistGurukulamEmailList(newList);
    if (success) {
      showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Added Gurukulam email recipient: ${email}`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to save email to server.`);
    }
  };

  const handleDeleteGurukulamEmail = async (indexToDelete) => {
    const currentList = getGurukulamEmailList();
    const newList = currentList.filter((_, idx) => idx !== indexToDelete);
    const success = await persistGurukulamEmailList(newList);
    if (success) {
      showPopup(`<i class="bi bi-trash-fill" style="margin-right: 8px; color: #e74c3c;"></i> Gurukulam email recipient removed.`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to remove email on server.`);
    }
  };

  const handleStartEditGurukulamEmail = (index, currentEmail) => {
    setEditingGurukulamEmailIndex(index);
    setEditingGurukulamEmailValue(currentEmail);
  };

  const handleSaveEditedGurukulamEmail = async (indexToSave) => {
    const email = editingGurukulamEmailValue.trim();
    if (!email) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Please enter a valid email address!`);
      return;
    }
    const currentList = getGurukulamEmailList();
    currentList[indexToSave] = email;
    setEditingGurukulamEmailIndex(null);
    setEditingGurukulamEmailValue("");
    const success = await persistGurukulamEmailList(currentList);
    if (success) {
      showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Gurukulam email recipient updated!`);
    } else {
      showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to save updated email.`);
    }
  };

  /* ================= POPUP ================= */
  const showPopup = (msg) => {
    const div = document.createElement("div");
    div.innerHTML = `
      <div style="
        position: fixed;
        top: 20px;
        right: 20px;
        background: #5d1d2b;
        color: #fff;
        padding: 14px 18px;
        border-radius: 10px;
        z-index: 99999;
        box-shadow: 0 10px 25px rgba(93, 29, 43, 0.25);
        font-size: 14px;
        font-weight: 600;
        max-width: 300px;
        animation: slideIn 0.3s ease;
      ">
        ${msg}
      </div>
      <style>
        @keyframes slideIn {
          from { transform: translateX(100px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      </style>
    `;
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 2500);
  };

  /* ================= COPY HELPER ================= */
  const handleCopy = (text, label) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    showPopup(`<i class="bi bi-clipboard-check" style="margin-right: 8px; color: #d4af37;"></i> Copied ${label} to clipboard!`);
  };

  /* ================= FETCH SETTINGS (RUNS ONCE ON MOUNT) ================= */
  const fetchSettings = useCallback(async () => {
    try {
      const setRes = await fetch(SITE_SETTINGS_API);
      const setContentType = setRes.headers.get("content-type");
      if (setContentType && setContentType.includes("application/json")) {
        const setData = await setRes.json();
        if (setData?.status === "success" && setData.settings) {
          if (setData.settings.google_donation_form_url) {
            setGoogleFormUrl(setData.settings.google_donation_form_url);
          }
          if (setData.settings.google_gurukulam_donation_form_url) {
            setGoogleGurukulamFormUrl(setData.settings.google_gurukulam_donation_form_url);
          }
          setPaymentSettings(prev => ({
            ...prev,
            ...setData.settings
          }));
        }
      }
    } catch (err) {
      console.error("Settings fetch error:", err);
    }
  }, []);

  /* ================= FETCH DATA (POLLED FOR TABLES) ================= */
  const fetchData = useCallback(async () => {
    try {
      const vivahRes = await fetch(VIVAHAPRAPTHI_API);
      if (vivahRes.ok) {
        const vivahData = await vivahRes.json();
        if (vivahData?.status === "success") {
          setVivahaprapthiList(Array.isArray(vivahData.data) ? vivahData.data : []);
        }
      }

      const vedaRes = await fetch(VEDAPATSHALA_ENQUIRY_API);
      const vedaContentType = vedaRes.headers.get("content-type");
      if (vedaContentType && vedaContentType.includes("application/json")) {
        const vedaData = await vedaRes.json();
        if (vedaData?.status === "success") {
          setVedapatshalaEntries(Array.isArray(vedaData.data) ? vedaData.data : []);
        }
      }

      const admRes = await fetch(GURUKULAM_ADMISSIONS_API);
      const admContentType = admRes.headers.get("content-type");
      if (admContentType && admContentType.includes("application/json")) {
        const admData = await admRes.json();
        if (admData?.status === "success") {
          setGurukulamAdmissions(Array.isArray(admData.data) ? admData.data : []);
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  /* ================= VIVAHAPRAPTHI HANDLERS ================= */
  const handleVivahStatusChange = async (id, newStatus) => {
    try {
      const res = await fetch(`${VIVAHAPRAPTHI_API}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: newStatus })
      });
      const data = await res.json();
      if (data.status === "success") {
        showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Registration updated to ${newStatus}`);
        fetchData();
        if (selectedVivahReg && selectedVivahReg.id === id) {
          setSelectedVivahReg((prev) => ({ ...prev, status: newStatus }));
        }
      } else {
        showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> ${data.message || "Failed to update status"}`);
      }
    } catch (err) {
      console.error("Status update error:", err);
      showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Failed to update status`);
    }
  };

  const handleVivahMarkAsPaid = async (id) => {
    const ref = await showPrompt({
      title: "Mark Vivahaprapthi Payment as Received (₹600)",
      message: "Enter Payment Reference / Mode (e.g., GPay UPI Ref, Bank IMPS, or Cash):",
      defaultValue: "Direct UPI / Admin Verified",
      confirmText: "Confirm Payment Received"
    });
    if (!ref || !ref.trim()) return;

    try {
      const res = await fetch(`${VIVAHAPRAPTHI_API}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id,
          status: "Paid",
          payment_details: `Direct Payment (${ref.trim()})`,
          payment_reference: ref.trim()
        })
      });
      const data = await res.json();
      if (data.status === "success") {
        showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Vivahaprapthi payment of ₹600 marked as Received & profile activated!`);
        fetchData();
        if (selectedVivahReg && selectedVivahReg.id === id) {
          setSelectedVivahReg((prev) => ({
            ...prev,
            status: "Paid",
            amount: "600.00",
            payment_details: `Direct Payment (${ref.trim()})`
          }));
        }
      } else {
        showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> ${data.message || "Failed to mark payment"}`);
      }
    } catch (err) {
      console.error("Mark as paid error:", err);
      showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Failed to update payment status`);
    }
  };

  const handleVivahDelete = async (id) => {
    const ok = await showConfirm({
      title: "Delete Registration",
      message: "Are you sure you want to delete this Vivahaprapthi registration?",
      subMessage: "This registration record will be permanently removed.",
      confirmText: "Delete Record",
      type: "danger"
    });
    if (!ok) return;
    try {
      const res = await fetch(VIVAHAPRAPTHI_API, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      const data = await res.json();
      if (data.status === "success") {
        showPopup(`<i class="bi bi-trash-fill" style="margin-right: 8px; color: #2ecc71;"></i> Registration record deleted successfully`);
        if (selectedVivahReg && selectedVivahReg.id === id) {
          setSelectedVivahReg(null);
        }
        fetchData();
      } else {
        showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> ${data.message || "Failed to delete registration"}`);
      }
    } catch (err) {
      console.error("Delete error:", err);
      showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Failed to delete registration`);
    }
  };

  const getFullProofURL = (path) => {
    return getImageUrl(path);
  };

  /* ================= INIT ================= */
  useEffect(() => {
    fetchSettings();
    fetchData();
    const interval = setInterval(fetchData, 8000);
    return () => clearInterval(interval);
  }, [fetchData, fetchSettings]);

  /* ================= SAVE SETTINGS ================= */
  const handleSaveSettings = async (e) => {
    e.preventDefault();
    try {
      setSavingSettings(true);
      const res = await fetch(SITE_SETTINGS_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          google_donation_form_url: googleFormUrl,
          google_gurukulam_donation_form_url: googleGurukulamFormUrl,
          ...paymentSettings
        }),
      });
      const data = await res.json();
      if (data?.status === "success") {
        showPopup(`<i class="bi bi-check-circle-fill" style="margin-right: 8px; color: #2ecc71;"></i> Payment Gateway & Email Settings updated successfully!`);
      } else {
        showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Failed to update settings`);
      }
    } catch (err) {
      console.error("Save error:", err);
      showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Server error`);
    } finally {
      setSavingSettings(false);
    }
  };

  // Get Initials for Avatar
  const getInitials = (name) => {
    if (!name) return "E";
    const parts = name.trim().split(" ");
    if (parts.length > 1) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  };

  /* ================= VIVAHAPRAPTHI PRE-FILLED WHATSAPP MESSAGE ================= */
  const getVivahWhatsAppMessage = (item) => {
    if (!item) return "";
    const name = item.contact_name || "Sir / Madam";
    const id = item.vivahaprapthi_id || "";
    const profileType = item.profile_type || "Bride / Groom";
    const statusLower = (item.status || "").toLowerCase();
    const isPaid = statusLower === "paid" || Boolean(item.payment_id);
    const isApproved = statusLower === "approved" && !isPaid;
    const cleanPhone = (item.contact_phone || "").replace(/\D/g, "").slice(-10);
    const subNum = item.subscription_number || "";
    const payUrl = subNum
      ? `https://vaithikasri.com/profile?tab=vivahaprapthi&user=${encodeURIComponent(subNum)}`
      : `https://vaithikasri.com/profile?tab=vivahaprapthi`;

    if (isApproved) {
      return `Namaskaram ${name},\n\nYour Vaithikasri Vivahaprapthi matrimonial enquiry for *${profileType}* (ID: *${id}*) has been *APPROVED* by our editorial team.\n\nTo publish your profile in the upcoming *Vaithikasri Monthly Print Magazine* edition and activate it across our online matrimonial directory for 3 months, kindly complete the publication fee of *₹600*.\n\n👉 *Pay ₹600 & Activate Profile:*\n${payUrl}\n\n🔑 *Login Details (if prompted):*\n• User ID: *${subNum || cleanPhone || "Your Subscription ID"}* (or your mobile number)\n• Password: *Your account password* (or default temporary password: *${cleanPhone || "10-digit mobile number"}*)\n_(Note: If you already set a custom password, please use that. Otherwise, enter your 10-digit mobile number to log in)_\n\nOnce paid, your official PDF receipt will be generated and your profile will be scheduled for print publication.\n\nFor any queries or assistance, please reply to this message.\n\nWith prayers & best wishes,\n*Vaithikasri Matrimonial Services*`;
    }

    if (isPaid) {
      return `Namaskaram ${name},\n\nYour Vaithikasri Vivahaprapthi matrimonial registration for *${profileType}* (ID: *${id}*) is *Paid & Active*.\n\nYour profile has been scheduled for publication in the upcoming Vaithikasri monthly print magazine edition.\n\n👉 *View Profile & Receipt:*\n${payUrl}\n\nWith best wishes,\n*Vaithikasri Matrimonial Services*`;
    }

    return `Namaskaram ${name},\n\nThank you for submitting your Vaithikasri Vivahaprapthi matrimonial enquiry for *${profileType}* (ID: *${id}*).\n\nOur administrative team is reviewing your profile details. Once approved, you can complete the ₹600 payment to print in the magazine.\n\n👉 *View Status:*\n${payUrl}\n\nWith best wishes,\n*Vaithikasri Matrimonial Services*`;
  };

  // STATS & FILTERED VIVAHAPRAPTHI
  const vivahTotalCount = vivahaprapthiList.length;
  const vivahPendingCount = vivahaprapthiList.filter((r) => (r.status || "Pending").toLowerCase() === "pending").length;
  const vivahContactedCount = vivahaprapthiList.filter((r) => (r.status || "").toLowerCase() === "contacted").length;
  const vivahPaidCount = vivahaprapthiList.filter((r) => (r.status || "").toLowerCase() === "paid" || Boolean(r.payment_id)).length;
  const vivahApprovedCount = vivahaprapthiList.filter((r) => {
    const s = (r.status || "").toLowerCase();
    const isPaid = s === "paid" || Boolean(r.payment_id);
    return s === "approved" && !isPaid;
  }).length;
  const vivahRejectedCount = vivahaprapthiList.filter((r) => (r.status || "").toLowerCase() === "rejected").length;

  const filteredVivahaprapthi = vivahaprapthiList.filter((r) => {
    const status = (r.status || "Pending").toLowerCase();
    const isPaid = status === "paid" || Boolean(r.payment_id);

    if (vivahaprapthiFilter === "Paid") {
      if (!isPaid) return false;
    } else if (vivahaprapthiFilter === "Approved") {
      if (status !== "approved" || isPaid) return false;
    } else if (vivahaprapthiFilter !== "All" && status !== vivahaprapthiFilter.toLowerCase()) {
      return false;
    }
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    return (
      (r.vivahaprapthi_id || "").toLowerCase().includes(query) ||
      (r.contact_name || "").toLowerCase().includes(query) ||
      (r.contact_phone || "").toLowerCase().includes(query) ||
      (r.caste_section || "").toLowerCase().includes(query) ||
      (r.subscription_number || "").toLowerCase().includes(query) ||
      (r.native_place || "").toLowerCase().includes(query) ||
      (r.profile_type || "").toLowerCase().includes(query)
    );
  });

  // Filtered Veda Patshala Entries
  const filteredVedapatshala = vedapatshalaEntries.filter((item) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    return (
      (item.name || "").toLowerCase().includes(query) ||
      (item.email || "").toLowerCase().includes(query) ||
      (item.phone || "").toLowerCase().includes(query) ||
      (item.question || "").toLowerCase().includes(query)
    );
  });

  // Filtered Gurukulam Admissions
  const filteredGurukulamAdmissions = gurukulamAdmissions.filter((item) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    return (
      (item.child_name || "").toLowerCase().includes(query) ||
      (item.parent_name || "").toLowerCase().includes(query) ||
      (item.contact_number || "").toLowerCase().includes(query) ||
      (item.email || "").toLowerCase().includes(query) ||
      (item.native_place || "").toLowerCase().includes(query) ||
      (item.kid_star || "").toLowerCase().includes(query)
    );
  });

  const deleteGurukulamAdmission = async (id) => {
    const ok = await showConfirm({
      title: "Delete Admission",
      message: "Are you sure you want to delete this admission application?",
      subMessage: "All student documents and admission details will be permanently removed.",
      confirmText: "Delete Admission",
      type: "danger"
    });
    if (!ok) return;
    try {
      const res = await fetch(`${GURUKULAM_ADMISSIONS_API}?id=${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data?.status === "success") {
        showPopup(`<i class="bi bi-trash-fill" style="margin-right: 8px; color: #e74c3c;"></i> Admission record deleted.`);
        fetchData();
      } else {
        showPopup(`<i class="bi bi-exclamation-triangle-fill" style="margin-right: 8px; color: #f39c12;"></i> Failed to delete admission.`);
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  /* ================= DELETE VEDAPATSHALA ================= */
  const deleteVedapatshalaEntry = async (id) => {
    const ok = await showConfirm({
      title: "Delete Enquiry",
      message: "Are you sure you want to delete this Veda Patshala enquiry?",
      subMessage: "This enquiry record will be permanently removed.",
      confirmText: "Delete Enquiry",
      type: "danger"
    });
    if (!ok) return;

    try {
      const res = await fetch(VEDAPATSHALA_ENQUIRY_API, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const result = await res.json();
      if (result?.status === "success") {
        setVedapatshalaEntries((prev) => prev.filter((item) => item.id !== id));
        showPopup(`<i class="bi bi-trash" style="margin-right: 8px; color: #ff6b6b;"></i> Enquiry deleted successfully`);
      } else {
        showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Delete failed`);
      }
    } catch (err) {
      console.error("Delete error:", err);
      showPopup(`<i class="bi bi-exclamation-circle" style="margin-right: 8px; color: #ff6b6b;"></i> Server error`);
    }
  };

  return (
    <div className="admin-container matrimonial-admin-container">

      {/* Header */}
      <div className="matrimonial-header">
        <div className="matrimonial-header-left">
          <h2>
            <i className="bi bi-file-earmark-text"></i> Forms Manager
          </h2>
          <p>Manage all incoming submissions for Donations, Vivahaprapthi Registrations, VedaPatashala Admissions, and configure Gateway & payment settings</p>
        </div>
      </div>

      {/* Tabs Navigation */}
      <div className="publications-tabs" style={{ display: "flex", gap: "10px", margin: "25px 0", borderBottom: "2px solid #eee", paddingBottom: "10px", flexWrap: "wrap" }}>
        <button
          type="button"
          className={`pub-tab-btn ${activeTab === "vivahaprapthi" ? "active" : ""}`}
          style={{
            padding: "10px 20px",
            border: "none",
            background: activeTab === "vivahaprapthi" ? "#5d1d2b" : "transparent",
            color: activeTab === "vivahaprapthi" ? "#fff" : "#555",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "0.2s"
          }}
          onClick={() => {
            setActiveTab("vivahaprapthi");
            setSearchQuery("");
          }}
        >
          <i className="bi bi-heart-fill" style={{ marginRight: "8px", color: "#d4af37" }}></i> Vivahaprapthi Enquiries ({vivahaprapthiList.length})
        </button>
        <button
          type="button"
          className={`pub-tab-btn ${activeTab === "vedapatshala" ? "active" : ""}`}
          style={{
            padding: "10px 20px",
            border: "none",
            background: activeTab === "vedapatshala" ? "#5d1d2b" : "transparent",
            color: activeTab === "vedapatshala" ? "#fff" : "#555",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "0.2s"
          }}
          onClick={() => {
            setActiveTab("vedapatshala");
            setSearchQuery("");
          }}
        >
          <i className="bi bi-mortarboard-fill" style={{ marginRight: "8px" }}></i> Gurukulam Admissions ({gurukulamAdmissions.length + vedapatshalaEntries.length})
        </button>
        <button
          type="button"
          className={`pub-tab-btn ${activeTab === "settings" ? "active" : ""}`}
          style={{
            padding: "10px 20px",
            border: "none",
            background: activeTab === "settings" ? "#5d1d2b" : "transparent",
            color: activeTab === "settings" ? "#fff" : "#555",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "0.2s"
          }}
          onClick={() => {
            setActiveTab("settings");
            setSearchQuery("");
          }}
        >
          <i className="bi bi-credit-card-2-front-fill" style={{ marginRight: "8px" }}></i> Payment & Form Settings
        </button>
      </div>

      {/* Search Filter (Visible for Enquiries tabs) */}
      {activeTab !== "settings" && (
        <div className="search-box-wrapper" style={{ marginBottom: "25px" }}>
          <i className="bi bi-search search-icon"></i>
          <input
            type="text"
            className="search-input admin-search-input"
            style={{ paddingLeft: "48px" }}
            placeholder={
              activeTab === "vivahaprapthi"
                ? "Search by Vivahaprapthi ID, contact name, phone, subscription no, caste, or native..."
                : "Search by name, email, phone, or question..."
            }
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      )}

      {loading ? (
        <div className="matrimonial-loading">
          <div className="spinner-border text-primary" role="status"></div>
          <p>Loading details...</p>
        </div>
      ) : (
        <>

          {/* TAB 2: VIVAHAPRAPTHI ENQUIRIES */}
          {activeTab === "vivahaprapthi" && (
            <div className="admin-vivah-container" style={{ padding: 0 }}>
              {/* STATS OVERVIEW CARDS */}
              <div className="admin-stats-grid mb-4">
                <div
                  className={`stat-card total ${vivahaprapthiFilter === "All" ? "border-primary" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #5d1d2b" }}
                  onClick={() => setVivahaprapthiFilter("All")}
                >
                  <div className="stat-value" style={{ color: "#5d1d2b" }}>{vivahTotalCount}</div>
                  <div className="stat-label">Total Enquiries</div>
                </div>

                <div
                  className={`stat-card pending ${vivahaprapthiFilter === "Pending" ? "border-warning" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #f39c12" }}
                  onClick={() => setVivahaprapthiFilter("Pending")}
                >
                  <div className="stat-value" style={{ color: "#f39c12" }}>{vivahPendingCount}</div>
                  <div className="stat-label">Pending / New</div>
                </div>

                <div
                  className={`stat-card pending ${vivahaprapthiFilter === "Contacted" ? "border-info" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #0b69a3" }}
                  onClick={() => setVivahaprapthiFilter("Contacted")}
                >
                  <div className="stat-value" style={{ color: "#0b69a3" }}>{vivahContactedCount}</div>
                  <div className="stat-label">Contacted</div>
                </div>

                <div
                  className={`stat-card approved ${vivahaprapthiFilter === "Approved" ? "border-warning" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #d4af37" }}
                  onClick={() => setVivahaprapthiFilter("Approved")}
                >
                  <div className="stat-value" style={{ color: "#d4af37" }}>{vivahApprovedCount}</div>
                  <div className="stat-label">Approved (Awaiting Pay)</div>
                </div>

                <div
                  className={`stat-card approved ${vivahaprapthiFilter === "Paid" ? "border-success" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #2e7d32" }}
                  onClick={() => setVivahaprapthiFilter("Paid")}
                >
                  <div className="stat-value" style={{ color: "#2e7d32" }}>{vivahPaidCount}</div>
                  <div className="stat-label">Paid & Active (₹600)</div>
                </div>

                <div
                  className={`stat-card rejected ${vivahaprapthiFilter === "Rejected" ? "border-danger" : ""}`}
                  style={{ cursor: "pointer", borderLeft: "4px solid #e74c3c" }}
                  onClick={() => setVivahaprapthiFilter("Rejected")}
                >
                  <div className="stat-value" style={{ color: "#e74c3c" }}>{vivahRejectedCount}</div>
                  <div className="stat-label">Rejected</div>
                </div>
              </div>

              {/* FILTER TABS */}
              <div className="filter-tabs-row mb-3" style={{ flexWrap: "wrap", gap: "8px" }}>
                {["All", "Pending", "Approved", "Paid", "Contacted", "Rejected"].map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    className={`filter-tab-btn ${vivahaprapthiFilter === tab ? "active" : ""}`}
                    onClick={() => setVivahaprapthiFilter(tab)}
                  >
                    {tab === "All"
                      ? `All (${vivahTotalCount})`
                      : tab === "Pending"
                      ? `Pending (${vivahPendingCount})`
                      : tab === "Approved"
                      ? `Approved - Awaiting Pay (${vivahApprovedCount})`
                      : tab === "Paid"
                      ? `Paid & Active (${vivahPaidCount})`
                      : tab === "Contacted"
                      ? `Contacted (${vivahContactedCount})`
                      : `Rejected (${vivahRejectedCount})`}
                  </button>
                ))}
              </div>

              {/* DATA TABLE */}
              <div className="table-card">
                {filteredVivahaprapthi.length === 0 ? (
                  <div className="empty-box" style={{ padding: "40px", textAlign: "center", color: "#777" }}>
                    <i className="bi bi-inbox fs-1 d-block mb-2 text-muted"></i>
                    No Vivahaprapthi matrimonial enquiries found for filter <strong>"{vivahaprapthiFilter}"</strong>.
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="admin-vivah-table">
                      <thead>
                        <tr>
                          <th>Enquiry ID</th>
                          <th>Bride / Groom</th>
                          <th>Contact Person</th>
                          <th>Direct Contact</th>
                          <th>Caste & Horoscope</th>
                          <th>Native / Work</th>
                          <th>Enquiry Status</th>
                          <th>Payment (₹600)</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredVivahaprapthi.map((item) => {
                          const cleanPhone = (item.contact_phone || "").replace(/\D/g, "");
                          const waPhone = cleanPhone.length === 10 ? `91${cleanPhone}` : cleanPhone;
                          const isPaid = (item.status || "").toLowerCase() === "paid" || Boolean(item.payment_id);
                          const isApproved = (item.status || "").toLowerCase() === "approved" && !isPaid;

                          return (
                            <tr key={item.id}>
                              <td>
                                <strong className="vivah-id-badge">{item.vivahaprapthi_id}</strong>
                                {item.subscription_number && (
                                  <div style={{ fontSize: "11px", color: "#888", marginTop: "2px" }}>
                                    Sub: {item.subscription_number}
                                  </div>
                                )}
                              </td>

                              <td>
                                <span className={`profile-badge ${item.profile_type === "Bride" ? "bride" : "groom"}`}>
                                  {item.profile_type}
                                </span>
                              </td>

                              <td>
                                <div><strong>{item.contact_name}</strong></div>
                                {item.contact_email && (
                                  <small className="text-muted d-block">{item.contact_email}</small>
                                )}
                              </td>

                              <td>
                                <div style={{ display: "flex", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
                                  <a
                                    href={`tel:${item.contact_phone}`}
                                    className="phone-link"
                                    title="Call Contact"
                                    style={{ fontSize: "12px", textDecoration: "none" }}
                                  >
                                    <i className="bi bi-telephone-fill me-1"></i> {item.contact_phone}
                                  </a>
                                  {cleanPhone && (
                                    <a
                                      href={`https://wa.me/${waPhone}?text=${encodeURIComponent(getVivahWhatsAppMessage(item))}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="badge bg-success"
                                      title="Chat on WhatsApp (Prefilled with Approval & ₹600 Payment Link)"
                                      style={{ textDecoration: "none", padding: "4px 8px" }}
                                    >
                                      <i className="bi bi-whatsapp"></i> WA
                                    </a>
                                  )}
                                </div>
                              </td>

                              <td>
                                <div><strong style={{ color: "#5d1d2b" }}>{item.caste_section}</strong></div>
                                <small className="text-muted d-block">
                                  {item.gothram ? `G: ${item.gothram}` : ""} {item.dob ? `| DOB: ${item.dob}` : ""}
                                </small>
                              </td>

                              <td>
                                <div><strong>{item.native_place || "N/A"}</strong></div>
                                <small className="text-muted d-block">{item.work || "N/A"}</small>
                              </td>

                              {/* ENQUIRY STATUS */}
                              <td>
                                <span className={`status-badge ${(item.status || "Pending").toLowerCase()}`}>
                                  {item.status || "Pending"}
                                </span>
                              </td>

                              {/* PAYMENT STATUS */}
                              <td>
                                {isPaid ? (
                                  <div>
                                    <span className="badge bg-success" style={{ padding: "5px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "700" }}>
                                      <i className="bi bi-check-circle-fill me-1"></i> Paid ₹600
                                    </span>
                                    {item.receipt_number && (
                                      <div style={{ fontSize: "11px", color: "#2e7d32", fontWeight: "700", marginTop: "3px" }}>
                                        {item.receipt_number}
                                      </div>
                                    )}
                                    {item.receipt_pdf && (
                                      <a
                                        href={`${API_BASE}/${item.receipt_pdf}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ fontSize: "10.5px", color: "#5d1d2b", textDecoration: "underline", display: "inline-block", marginTop: "2px", fontWeight: "600" }}
                                      >
                                        <i className="bi bi-file-earmark-pdf me-1"></i> Receipt PDF
                                      </a>
                                    )}
                                  </div>
                                ) : isApproved ? (
                                  <div>
                                    <span className="badge bg-warning text-dark" style={{ padding: "5px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "700" }}>
                                      <i className="bi bi-clock-history me-1"></i> Awaiting ₹600
                                    </span>
                                    <small className="text-muted d-block" style={{ fontSize: "10.5px", marginTop: "2px" }}>
                                      Payment Pending
                                    </small>
                                  </div>
                                ) : (item.status || "").toLowerCase() === "pending" ? (
                                  <div>
                                    <span className="badge bg-light text-secondary border" style={{ padding: "4px 8px", borderRadius: "10px", fontSize: "10.5px" }}>
                                      Under Review
                                    </span>
                                  </div>
                                ) : (
                                  <div>
                                    <span className="badge bg-light text-muted border" style={{ padding: "4px 8px", borderRadius: "10px", fontSize: "10.5px" }}>
                                      —
                                    </span>
                                  </div>
                                )}
                              </td>

                              <td>
                                <small className="text-muted">
                                  {new Date(item.created_at).toLocaleDateString()}
                                </small>
                              </td>

                              <td>
                                <div className="action-btn-group">
                                  <button
                                    type="button"
                                    className="btn-action view"
                                    title="View Full Enquiry & Payment Details"
                                    onClick={() => setSelectedVivahReg(item)}
                                  >
                                    <i className="bi bi-eye"></i> View
                                  </button>

                                  {(item.status || "Pending").toLowerCase() === "pending" && (
                                    <button
                                      type="button"
                                      className="btn-action"
                                      style={{ background: "#0b69a3", color: "#fff", borderColor: "#0b69a3" }}
                                      title="Mark as Contacted"
                                      onClick={() => handleVivahStatusChange(item.id, "Contacted")}
                                    >
                                      <i className="bi bi-telephone-outbound"></i> Contacted
                                    </button>
                                  )}

                                  {item.status !== "Approved" && item.status !== "Paid" && (
                                    <button
                                      type="button"
                                      className="btn-action approve"
                                      title="Approve Profile"
                                      onClick={() => handleVivahStatusChange(item.id, "Approved")}
                                    >
                                      Approve
                                    </button>
                                  )}

                                  {!isPaid && (
                                    <button
                                      type="button"
                                      className="btn-action"
                                      style={{ background: "#2e7d32", color: "#fff" }}
                                      title="Mark Payment as Received (Direct / Offline)"
                                      onClick={() => handleVivahMarkAsPaid(item.id)}
                                    >
                                      <i className="bi bi-cash-coin me-1"></i> Mark Paid
                                    </button>
                                  )}

                                  {item.status !== "Rejected" && (
                                    <button
                                      type="button"
                                      className="btn-action reject"
                                      title="Reject Profile"
                                      onClick={() => handleVivahStatusChange(item.id, "Rejected")}
                                    >
                                      Reject
                                    </button>
                                  )}

                                  <button
                                    type="button"
                                    className="btn-action delete"
                                    title="Delete Record"
                                    onClick={() => handleVivahDelete(item.id)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* VIEW DETAILS MODAL */}
              {selectedVivahReg && (
                <div className="admin-modal-overlay" onClick={() => setSelectedVivahReg(null)}>
                  <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header-maroon" style={{ background: "#5d1d2b" }}>
                      <div>
                        <h3>Enquiry Details: <span>{selectedVivahReg.vivahaprapthi_id}</span></h3>
                        <span className={`status-badge ${(selectedVivahReg.status || "Pending").toLowerCase()}`}>
                          {selectedVivahReg.status || "Pending"}
                        </span>
                      </div>
                      <button type="button" className="btn-close-modal" onClick={() => setSelectedVivahReg(null)}>&times;</button>
                    </div>

                    <div className="modal-body-content">
                      {/* QUICK COMMUNICATION TOOLBAR */}
                      <div style={{
                        background: "#fdfbf7",
                        border: "1px solid #ebdcb9",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        marginBottom: "18px",
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap"
                      }}>
                        <span style={{ fontSize: "13px", fontWeight: "bold", color: "#5d1d2b" }}>
                          <i className="bi bi-headset me-1"></i> Quick Action:
                        </span>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          <a
                            href={`tel:${selectedVivahReg.contact_phone}`}
                            className="btn btn-sm"
                            style={{ background: "#5d1d2b", color: "#fff", fontSize: "12px", padding: "6px 12px", textDecoration: "none", borderRadius: "6px" }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i> Call {selectedVivahReg.contact_phone}
                          </a>
                          {selectedVivahReg.contact_phone && (
                            <a
                              href={`https://wa.me/${selectedVivahReg.contact_phone.replace(/\D/g, "").length === 10 ? "91" + selectedVivahReg.contact_phone.replace(/\D/g, "") : selectedVivahReg.contact_phone.replace(/\D/g, "")}?text=${encodeURIComponent(getVivahWhatsAppMessage(selectedVivahReg))}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-success"
                              style={{ fontSize: "12px", padding: "6px 12px", textDecoration: "none", borderRadius: "6px" }}
                              title="Send WhatsApp Message with Pre-filled Approval & ₹600 Payment Link"
                            >
                              <i className="bi bi-whatsapp me-1"></i> WhatsApp
                            </a>
                          )}
                          {selectedVivahReg.contact_email && (
                            <a
                              href={`mailto:${selectedVivahReg.contact_email}`}
                              className="btn btn-sm btn-info text-white"
                              style={{ fontSize: "12px", padding: "6px 12px", textDecoration: "none", borderRadius: "6px" }}
                            >
                              <i className="bi bi-envelope-fill me-1"></i> Email
                            </a>
                          )}
                        </div>
                      </div>

                      {/* PAYMENT & ACTIVATION DETAILS CARD */}
                      {(() => {
                        const isPaid = (selectedVivahReg.status || "").toLowerCase() === "paid" || Boolean(selectedVivahReg.payment_id);
                        const isApproved = (selectedVivahReg.status || "").toLowerCase() === "approved" && !isPaid;
                        return (
                          <div style={{
                            background: isPaid ? "#f4faf6" : isApproved ? "#fffdf5" : "#fdfbf9",
                            border: isPaid ? "1.5px solid #27ae60" : isApproved ? "1.5px solid #d4af37" : "1px solid #ebdcb9",
                            borderRadius: "10px",
                            padding: "16px",
                            marginBottom: "18px"
                          }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", borderBottom: "1px dashed rgba(0,0,0,0.1)", paddingBottom: "8px", flexWrap: "wrap", gap: "8px" }}>
                              <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "800", color: "#5d1d2b" }}>
                                <i className="bi bi-credit-card-2-front-fill me-2" style={{ color: "#d4af37" }}></i>
                                Payment & Activation Details
                              </h4>
                              {isPaid ? (
                                <span className="badge bg-success" style={{ padding: "6px 12px", borderRadius: "14px", fontSize: "12px", fontWeight: "bold" }}>
                                  <i className="bi bi-check-circle-fill me-1"></i> Paid ₹600 (Active Profile)
                                </span>
                              ) : isApproved ? (
                                <span className="badge bg-warning text-dark" style={{ padding: "6px 12px", borderRadius: "14px", fontSize: "12px", fontWeight: "bold" }}>
                                  <i className="bi bi-clock-history me-1"></i> Approved • Awaiting User Payment (₹600)
                                </span>
                              ) : (
                                <span className="badge bg-secondary" style={{ padding: "6px 12px", borderRadius: "14px", fontSize: "12px" }}>
                                  Not Paid • Under Review
                                </span>
                              )}
                            </div>

                            <div className="row g-2" style={{ fontSize: "13px" }}>
                              <div className="col-md-3 col-6">
                                <span style={{ fontSize: "11px", color: "#888", display: "block", fontWeight: "bold" }}>PACKAGE FEE:</span>
                                <strong style={{ fontSize: "14px", color: "#5d1d2b" }}>₹{selectedVivahReg.amount || "600.00"}</strong>
                                <small className="text-muted d-block" style={{ fontSize: "10.5px" }}>3 Months (90 Days)</small>
                              </div>
                              <div className="col-md-4 col-6">
                                <span style={{ fontSize: "11px", color: "#888", display: "block", fontWeight: "bold" }}>PAYMENT MODE / NOTE:</span>
                                <strong style={{ color: isPaid ? "#2e7d32" : "#333" }}>{selectedVivahReg.payment_details || "Awaiting Payment"}</strong>
                              </div>
                              <div className="col-md-5 col-12">
                                <span style={{ fontSize: "11px", color: "#888", display: "block", fontWeight: "bold" }}>RECEIPT NUMBER:</span>
                                {selectedVivahReg.receipt_number ? (
                                  <strong style={{ color: "#2e7d32" }}>{selectedVivahReg.receipt_number}</strong>
                                ) : (
                                  <span className="text-muted">Not generated yet (Pending Payment)</span>
                                )}
                              </div>
                              {selectedVivahReg.payment_id && (
                                <div className="col-md-6 col-12 mt-2">
                                  <span style={{ fontSize: "11px", color: "#888", display: "block", fontWeight: "bold" }}>PAYMENT ID:</span>
                                  <code style={{ fontSize: "12px", color: "#0b69a3" }}>{selectedVivahReg.payment_id}</code>
                                </div>
                              )}
                              {selectedVivahReg.receipt_pdf && (
                                <div className="col-md-6 col-12 mt-2">
                                  <span style={{ fontSize: "11px", color: "#888", display: "block", fontWeight: "bold" }}>OFFICIAL RECEIPT PDF:</span>
                                  <a
                                    href={`${API_BASE}/${selectedVivahReg.receipt_pdf}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm mt-1"
                                    style={{ background: "#5d1d2b", color: "#fff", fontSize: "12px", padding: "4px 10px", borderRadius: "6px", textDecoration: "none" }}
                                  >
                                    <i className="bi bi-file-earmark-pdf-fill me-1 text-danger"></i> View / Download Receipt PDF
                                  </a>
                                </div>
                              )}
                            </div>

                            {/* DIRECT MARK AS PAID HELPER IF NOT PAID */}
                            {!isPaid && (
                              <div style={{ marginTop: "12px", paddingTop: "10px", borderTop: "1px dashed rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                                <small className="text-muted">
                                  <i className="bi bi-info-circle me-1"></i> Subscriber paid via GPay / UPI / Bank Transfer / Cash?
                                </small>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-success"
                                  style={{ fontWeight: "bold", fontSize: "12px", padding: "4px 12px" }}
                                  onClick={() => handleVivahMarkAsPaid(selectedVivahReg.id)}
                                >
                                  <i className="bi bi-cash-coin me-1"></i> Mark as Paid (Direct / Offline)
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })()}

                      {/* DETAILS GRID */}
                      <div className="details-section-grid">
                        <div className="detail-box">
                          <span className="box-label">BRIDE / GROOM:</span>
                          <strong style={{ color: "#5d1d2b" }}>{selectedVivahReg.profile_type}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">SUBSCRIPTION NUMBER:</span>
                          <strong>{selectedVivahReg.subscription_number || "N/A (New)"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">CONTACT PERSON:</span>
                          <strong>{selectedVivahReg.contact_name}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">CONTACT PHONE:</span>
                          <strong>{selectedVivahReg.contact_phone}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">CONTACT EMAIL:</span>
                          <strong>{selectedVivahReg.contact_email || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">CASTE SECTION:</span>
                          <strong>{selectedVivahReg.caste_section}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">GOTHRAM:</span>
                          <strong>{selectedVivahReg.gothram || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">DATE OF BIRTH:</span>
                          <strong>{selectedVivahReg.dob || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">NAKSHATHRA / RASI:</span>
                          <strong>{selectedVivahReg.nakshathra || "N/A"} / {selectedVivahReg.rasi || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">HEIGHT / WEIGHT:</span>
                          <strong>{selectedVivahReg.height || "N/A"} / {selectedVivahReg.weight || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">QUALIFICATION:</span>
                          <strong>{selectedVivahReg.educational_qualification || "N/A"}</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">WORK & SALARY:</span>
                          <strong>{selectedVivahReg.work || "N/A"} ({selectedVivahReg.salary || "N/A"})</strong>
                        </div>

                        <div className="detail-box">
                          <span className="box-label">NATIVE / LOCATION:</span>
                          <strong>{selectedVivahReg.native_place || "N/A"}</strong>
                        </div>

                        <div className="detail-box full">
                          <span className="box-label">PARTNER EXPECTATIONS:</span>
                          <p className="mb-0">{selectedVivahReg.expectations || "None specified"}</p>
                        </div>

                        {(selectedVivahReg.publish_from || selectedVivahReg.publish_to) && (
                          <div className="detail-box full">
                            <span className="box-label">PREFERRED PUBLICATION PERIOD:</span>
                            <strong>{selectedVivahReg.publish_from || "N/A"} to {selectedVivahReg.publish_to || "N/A"}</strong>
                          </div>
                        )}
                      </div>

                      {/* LEGACY ATTACHMENT PREVIEW IF ANY */}
                      {selectedVivahReg.payment_proof && (
                        <div className="proof-section mt-4">
                          <h4 className="proof-title"><i className="bi bi-file-earmark-pdf me-2"></i> Attached Document / File</h4>
                          {selectedVivahReg.payment_proof.endsWith(".pdf") ? (
                            <a
                              href={getFullProofURL(selectedVivahReg.payment_proof)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn-pdf-download"
                            >
                              <i className="bi bi-file-earmark-pdf-fill me-2 text-danger"></i> View / Download PDF
                            </a>
                          ) : (
                            <div className="proof-img-box">
                              <img
                                src={getFullProofURL(selectedVivahReg.payment_proof)}
                                alt="Document"
                                className="modal-proof-img"
                              />
                              <a
                                href={getFullProofURL(selectedVivahReg.payment_proof)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-open-full mt-2"
                              >
                                <i className="bi bi-box-arrow-up-right me-1"></i> Open Original File
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="modal-footer-actions" style={{ flexWrap: "wrap", gap: "8px" }}>
                      {(selectedVivahReg.status || "Pending").toLowerCase() === "pending" && (
                        <button
                          type="button"
                          className="btn-modal-approve"
                          style={{ background: "#0b69a3", borderColor: "#0b69a3" }}
                          onClick={() => handleVivahStatusChange(selectedVivahReg.id, "Contacted")}
                        >
                          <i className="bi bi-telephone-outbound me-1"></i> Mark Contacted
                        </button>
                      )}

                      {selectedVivahReg.status !== "Approved" && (selectedVivahReg.status || "").toLowerCase() !== "paid" && (
                        <button
                          type="button"
                          className="btn-modal-approve"
                          onClick={() => handleVivahStatusChange(selectedVivahReg.id, "Approved")}
                        >
                          <i className="bi bi-check-lg me-1"></i> Approve
                        </button>
                      )}

                      {(selectedVivahReg.status || "").toLowerCase() !== "paid" && !selectedVivahReg.payment_id && (
                        <button
                          type="button"
                          className="btn-modal-approve"
                          style={{ background: "#2e7d32", borderColor: "#2e7d32" }}
                          onClick={() => handleVivahMarkAsPaid(selectedVivahReg.id)}
                        >
                          <i className="bi bi-cash-coin me-1"></i> Mark as Paid (₹600)
                        </button>
                      )}

                      {selectedVivahReg.status !== "Rejected" && (
                        <button
                          type="button"
                          className="btn-modal-reject"
                          onClick={() => handleVivahStatusChange(selectedVivahReg.id, "Rejected")}
                        >
                          <i className="bi bi-x-lg me-1"></i> Reject
                        </button>
                      )}

                      <button type="button" className="btn-modal-close" onClick={() => setSelectedVivahReg(null)}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 3.5: VEDAPATSHALA / GURUKULAM ADMISSIONS */}
          {activeTab === "vedapatshala" && (
            <div>
              {/* SECTION: GURUKULAM ADMISSION FORM APPLICATIONS */}
              <div className="mb-4">
                <h4 style={{ color: "#5d1d2b", fontWeight: "bold", borderBottom: "2px solid #5d1d2b", paddingBottom: "8px", marginBottom: "20px" }}>
                  <i className="bi bi-file-earmark-person-fill me-2" style={{ color: "#bc9341" }}></i> SEETHARAMA GURUKULAM TRUST - ADMISSION APPLICATIONS ({filteredGurukulamAdmissions.length})
                </h4>

                {filteredGurukulamAdmissions.length === 0 ? (
                  <div className="no-results-card mb-4" style={{ padding: "30px" }}>
                    <i className="bi bi-inbox" style={{ fontSize: "32px", color: "#aaa" }}></i>
                    <h5 style={{ color: "#666", marginTop: "10px" }}>No Gurukulam admission form submissions found</h5>
                  </div>
                ) : (
                  <div className="enquiries-card-grid mb-4">
                    {filteredGurukulamAdmissions.map((item) => (
                      <div key={item.id} className="enquiry-card" style={{ border: "2px solid #5d1d2b", background: "#ffffff" }}>
                        {/* Card Header */}
                        <div className="enquiry-card-header" style={{ borderBottom: "1px solid #eee" }}>
                          <div className="avatar-initials" style={{ background: "#5d1d2b", color: "#fff" }}>{getInitials(item.child_name || item.parent_name)}</div>
                          <div className="header-meta">
                            <h3 className="meta-name" style={{ color: "#5d1d2b", fontWeight: "bold" }}>{item.child_name} <span style={{ fontSize: "12px", color: "#bc9341", fontWeight: "normal" }}>(Child)</span></h3>
                            <p className="meta-date">
                              <i className="bi bi-calendar3"></i> Applied: {new Date(item.created_at).toLocaleDateString("en-IN", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit"
                              })}
                            </p>
                          </div>
                        </div>

                        {/* Child & Family Details Grid */}
                        <div style={{ background: "#fdfbf9", border: "1px solid #ebdcb9", borderRadius: "8px", padding: "12px", margin: "12px 0", fontSize: "13px" }}>
                          <div className="row g-2 mb-2">
                            <div className="col-6"><strong>DOB:</strong> {item.date_of_birth || "N/A"}</div>
                            <div className="col-6"><strong>Age:</strong> {item.age ? `${item.age} Years` : "N/A"}</div>
                            <div className="col-6"><strong>Star (Nakshatram):</strong> <span className="badge bg-warning text-dark">{item.kid_star || "N/A"}</span></div>
                            <div className="col-6"><strong>Native:</strong> {item.native_place || "N/A"}</div>
                          </div>
                          <div className="border-top pt-2 mt-2">
                            <div><strong>Education:</strong> {item.education_details || "N/A"}</div>
                            <div><strong>Parent:</strong> {item.parent_name} ({item.occupation || "N/A"})</div>
                            <div><strong>Father's Gothram:</strong> {item.father_gothram || "N/A"} | <strong>Mother's:</strong> {item.mother_gothram || "N/A"}</div>
                            <div><strong>Place of Living:</strong> {item.place_of_living || "N/A"}</div>
                          </div>
                        </div>

                        {/* Contact & Identification */}
                        <div className="enquiry-contact-info">
                          <div className="contact-row">
                            <span className="contact-label"><i className="bi bi-telephone"></i> Phone:</span>
                            <span className="contact-value">
                              {item.contact_number}
                              <button className="copy-btn" onClick={() => handleCopy(item.contact_number, "phone")} title="Copy Phone">
                                <i className="bi bi-clipboard"></i>
                              </button>
                            </span>
                          </div>
                          <div className="contact-row">
                            <span className="contact-label"><i className="bi bi-envelope"></i> Email:</span>
                            <span className="contact-value">
                              {item.email}
                              <button className="copy-btn" onClick={() => handleCopy(item.email, "email")} title="Copy Email">
                                <i className="bi bi-clipboard"></i>
                              </button>
                            </span>
                          </div>
                          <div className="contact-row">
                            <span className="contact-label"><i className="bi bi-card-heading"></i> Kid Aadhaar:</span>
                            <span className="contact-value">{item.kid_aadhar_number || "N/A"}</span>
                          </div>
                        </div>

                        {/* Purpose */}
                        <div className="enquiry-message-box mt-2">
                          <div className="message-label" style={{ color: "#5d1d2b" }}>Purpose of Joining Gurukulam</div>
                          <div className="message-content" style={{ fontSize: "13px", fontStyle: "italic" }}>{item.purpose_of_joining || "N/A"}</div>
                        </div>

                        {/* Document Attachments Buttons */}
                        <div className="d-flex flex-wrap gap-2 mt-3 p-2 bg-light rounded border">
                          {item.aadhar_copy ? (
                            <a href={`${API_BASE}${item.aadhar_copy}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary" style={{ fontSize: "11px" }}>
                              <i className="bi bi-file-earmark-pdf me-1"></i> Aadhaar Copy
                            </a>
                          ) : <span className="badge bg-secondary text-light" style={{ fontSize: "10px" }}>No Aadhaar Copy</span>}

                          {item.bank_passbook_copy ? (
                            <a href={`${API_BASE}${item.bank_passbook_copy}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary" style={{ fontSize: "11px" }}>
                              <i className="bi bi-bank me-1"></i> Passbook Copy
                            </a>
                          ) : <span className="badge bg-secondary text-light" style={{ fontSize: "10px" }}>No Passbook Copy</span>}

                          {item.birth_certificate_copy ? (
                            <a href={`${API_BASE}${item.birth_certificate_copy}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary" style={{ fontSize: "11px" }}>
                              <i className="bi bi-file-earmark-text me-1"></i> Birth Certificate
                            </a>
                          ) : <span className="badge bg-secondary text-light" style={{ fontSize: "10px" }}>No Birth Cert</span>}
                        </div>

                        {/* Declaration Notice */}
                        <div style={{ fontSize: "11px", color: "#5d1d2b", fontWeight: "bold", background: "#fdfbf9", padding: "6px 10px", borderRadius: "4px", margin: "10px 0 0 0" }}>
                          ✓ Declaration Verified (All details certified true)
                        </div>

                        {/* Actions */}
                        <div className="card-actions-row mt-3">
                          <button className="btn-delete-enquiry" onClick={() => deleteGurukulamAdmission(item.id)}>
                            <i className="bi bi-trash3"></i> Delete Application
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* SECTION: BASIC ENQUIRIES */}
              {filteredVedapatshala.length > 0 && (
                <div>
                  <h5 style={{ color: "#666", fontWeight: "bold", marginBottom: "15px" }}>General Admission Enquiries ({filteredVedapatshala.length})</h5>
                  <div className="enquiries-card-grid">
                    {filteredVedapatshala.map((item) => (
                      <div key={item.id} className="enquiry-card">
                        <div className="enquiry-card-header">
                          <div className="avatar-initials" style={{ background: "#5d1d2b", color: "#fff" }}>{getInitials(item.name)}</div>
                          <div className="header-meta">
                            <h3 className="meta-name">{item.name}</h3>
                            <p className="meta-date">
                              <i className="bi bi-calendar3"></i> {new Date(item.created_at).toLocaleDateString(undefined, {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit"
                              })}
                            </p>
                          </div>
                        </div>

                        <div className="enquiry-contact-info">
                          <div className="contact-row">
                            <span className="contact-label"><i className="bi bi-envelope"></i> Email:</span>
                            <span className="contact-value">{item.email}</span>
                          </div>
                          <div className="contact-row">
                            <span className="contact-label"><i className="bi bi-telephone"></i> Phone:</span>
                            <span className="contact-value">{item.phone}</span>
                          </div>
                        </div>

                        <div className="enquiry-message-box">
                          <div className="message-label">Enquiry Message</div>
                          <div className="message-content">{item.question}</div>
                        </div>

                        <div className="card-actions-row">
                          <button className="btn-delete-enquiry" onClick={() => deleteVedapatshalaEntry(item.id)}>
                            <i className="bi bi-trash3"></i> Delete Enquiry
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 4: SETTINGS */}
          {activeTab === "settings" && (
            <div className="bg-white p-4 rounded-3 shadow-sm" style={{ borderTop: "5px solid #5d1d2b", maxWidth: "900px", margin: "0 auto" }}>
              <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                <div>
                  <h3 className="m-0 fw-bold" style={{ color: "#5d1d2b" }}>
                    <i className="bi bi-credit-card-2-front-fill me-2" style={{ color: "#bc9341" }}></i> Payment & Gateway Settings
                  </h3>
                  <p className="text-muted mb-0 mt-1" style={{ fontSize: "14px" }}>
                    Manage live payment gateway (Razorpay) and admin notification emails for the website.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSaveSettings}>
                {/* 1. VAITHIKASRI ADMIN EMAILS */}
                <div className="p-4 border rounded-3 mb-4 text-start shadow-sm" style={{ background: "#ffffff", borderColor: "#e5d5c5", borderLeft: "5px solid #5d1d2b" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                    <div>
                      <h5 style={{ color: "#5d1d2b", fontWeight: "bold", margin: 0, textTransform: "uppercase", fontSize: "15px" }}>
                        <i className="bi bi-envelope-paper-heart me-2" style={{ color: "#bc9341" }}></i> 📖 Vaithikasri Admin Email Controls
                      </h5>
                      <p style={{ color: "#666", fontSize: "13px", margin: "4px 0 0 0" }}>
                        Receives alerts for <strong>Magazine Subscriptions</strong>, <strong>Vivahaprapthi Matrimonial</strong> registrations, ₹600 payments, <strong>Vaithikasri Donations</strong>, and Book Orders.
                      </p>
                    </div>
                    <span className="badge" style={{ background: "#5d1d2b", color: "#ffd700", padding: "6px 12px", fontSize: "11px", fontWeight: "700" }}>
                      VAITHIKASRI SERVICES
                    </span>
                  </div>

                  <div className="p-3 border rounded mb-3 mt-3 text-start" style={{ background: "#fdfbf9", borderColor: "#eee0c9" }}>
                    <label style={{ fontWeight: "700", color: "#5d1d2b", display: "block", marginBottom: "10px", fontSize: "13px" }}>
                      Active Vaithikasri Email Recipients ({getVaithikasriEmailList().length})
                    </label>

                    {getVaithikasriEmailList().length === 0 ? (
                      <div className="text-muted small italic mb-3">No Vaithikasri admin emails configured. (Fallback SMTP user will be used).</div>
                    ) : (
                      <div className="d-flex flex-column gap-2 mb-3">
                        {getVaithikasriEmailList().map((email, idx) => (
                          <div key={idx} className="d-flex align-items-center justify-content-between p-2 bg-white border rounded shadow-sm">
                            {editingVaithikasriEmailIndex === idx ? (
                              <div className="d-flex align-items-center gap-2 w-100">
                                <input
                                  type="email"
                                  className="form-control form-control-sm"
                                  value={editingVaithikasriEmailValue}
                                  onChange={(e) => setEditingVaithikasriEmailValue(e.target.value)}
                                  style={{ fontSize: "14px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success text-nowrap"
                                  onClick={() => handleSaveEditedVaithikasriEmail(idx)}
                                >
                                  <i className="bi bi-check-lg"></i> Save
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary text-nowrap"
                                  onClick={() => setEditingVaithikasriEmailIndex(null)}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <>
                                <span style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                  <i className="bi bi-envelope-fill text-danger me-2"></i> {email}
                                </span>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleStartEditVaithikasriEmail(idx, email)}
                                    title="Edit Email"
                                  >
                                    <i className="bi bi-pencil-square"></i> Edit
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteVaithikasriEmail(idx)}
                                    title="Remove Email"
                                  >
                                    <i className="bi bi-trash"></i> Delete
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="row g-2 align-items-center">
                      <div className="col">
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          placeholder="Add Vaithikasri admin email (e.g. admin@vaithikasri.com)..."
                          value={newVaithikasriEmailInput}
                          onChange={(e) => setNewVaithikasriEmailInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleAddVaithikasriEmail();
                            }
                          }}
                          style={{ fontSize: "13.5px" }}
                        />
                      </div>
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-sm"
                          style={{ background: "#5d1d2b", color: "#fff", fontWeight: "bold", fontSize: "13px" }}
                          onClick={handleAddVaithikasriEmail}
                        >
                          <i className="bi bi-plus-circle me-1"></i> Add Email
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. SRI SEETHARAMA GURUKULAM TRUST ADMIN EMAILS */}
                <div className="p-4 border rounded-3 mb-4 text-start shadow-sm" style={{ background: "#ffffff", borderColor: "#ebdcb9", borderLeft: "5px solid #bc9341" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                    <div>
                      <h5 style={{ color: "#5d1d2b", fontWeight: "bold", margin: 0, textTransform: "uppercase", fontSize: "15px" }}>
                        <i className="bi bi-mortarboard-fill me-2" style={{ color: "#bc9341" }}></i> 🛕 Sri Seetharama Gurukulam Trust Email Controls
                      </h5>
                      <p style={{ color: "#666", fontSize: "13px", margin: "4px 0 0 0" }}>
                        Receives alerts for <strong>Gurukulam Student Admissions</strong> (with documents), <strong>Veda Patshala Course Enquiries</strong>, and <strong>Gurukulam Trust Donations</strong>.
                      </p>
                    </div>
                    <span className="badge" style={{ background: "#bc9341", color: "#fff", padding: "6px 12px", fontSize: "11px", fontWeight: "700" }}>
                      GURUKULAM TRUST
                    </span>
                  </div>

                  <div className="p-3 border rounded mb-3 mt-3 text-start" style={{ background: "#fdfbf9", borderColor: "#eee0c9" }}>
                    <label style={{ fontWeight: "700", color: "#5d1d2b", display: "block", marginBottom: "10px", fontSize: "13px" }}>
                      Active Gurukulam Trust Email Recipients ({getGurukulamEmailList().length})
                    </label>

                    {getGurukulamEmailList().length === 0 ? (
                      <div className="text-muted small italic mb-3">No Gurukulam Trust emails configured. (Fallback SMTP user will be used).</div>
                    ) : (
                      <div className="d-flex flex-column gap-2 mb-3">
                        {getGurukulamEmailList().map((email, idx) => (
                          <div key={idx} className="d-flex align-items-center justify-content-between p-2 bg-white border rounded shadow-sm">
                            {editingGurukulamEmailIndex === idx ? (
                              <div className="d-flex align-items-center gap-2 w-100">
                                <input
                                  type="email"
                                  className="form-control form-control-sm"
                                  value={editingGurukulamEmailValue}
                                  onChange={(e) => setEditingGurukulamEmailValue(e.target.value)}
                                  style={{ fontSize: "14px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success text-nowrap"
                                  onClick={() => handleSaveEditedGurukulamEmail(idx)}
                                >
                                  <i className="bi bi-check-lg"></i> Save
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary text-nowrap"
                                  onClick={() => setEditingGurukulamEmailIndex(null)}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <>
                                <span style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                  <i className="bi bi-envelope-fill text-warning me-2" style={{ color: "#bc9341" }}></i> {email}
                                </span>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleStartEditGurukulamEmail(idx, email)}
                                    title="Edit Email"
                                  >
                                    <i className="bi bi-pencil-square"></i> Edit
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteGurukulamEmail(idx)}
                                    title="Remove Email"
                                  >
                                    <i className="bi bi-trash"></i> Delete
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="row g-2 align-items-center">
                      <div className="col">
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          placeholder="Add Gurukulam Trust admin email (e.g. trust@gurukulam.org)..."
                          value={newGurukulamEmailInput}
                          onChange={(e) => setNewGurukulamEmailInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleAddGurukulamEmail();
                            }
                          }}
                          style={{ fontSize: "13.5px" }}
                        />
                      </div>
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-sm"
                          style={{ background: "#bc9341", color: "#fff", fontWeight: "bold", fontSize: "13px" }}
                          onClick={handleAddGurukulamEmail}
                        >
                          <i className="bi bi-plus-circle me-1"></i> Add Email
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <hr style={{ margin: "30px 0", borderTop: "1px dashed #ccc" }} />

                {/* ================= RAZORPAY GATEWAY CREDENTIALS CONTROLS ================= */}
                <div className="p-4 border rounded-3 mb-4 text-start shadow-sm" style={{ background: "#fdfbf7", borderColor: "#bc9341", borderLeft: "5px solid #5d1d2b" }}>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div>
                      <h5 style={{ color: "#5d1d2b", fontWeight: "bold", margin: 0, fontSize: "16px", textTransform: "uppercase" }}>
                        <i className="bi bi-credit-card-2-front-fill me-2" style={{ color: "#bc9341" }}></i> Razorpay Payment Gateway Controls (Live / Test Keys)
                      </h5>
                      <p className="text-muted small mb-0 mt-1" style={{ fontSize: "13px" }}>
                        Activate live online payments (UPI, Debit/Credit Cards, Netbanking) instantly across <strong>Donations</strong>, <strong>Magazine Subscriptions</strong>, and <strong>Book Orders</strong> by updating your Razorpay keys here.
                      </p>
                    </div>
                    <div>
                      {(paymentSettings.razorpay_mode === "live" || (paymentSettings.razorpay_key_id && paymentSettings.razorpay_key_id.startsWith("rzp_live"))) ? (
                        <span className="badge" style={{ background: "#27ae60", color: "#fff", padding: "8px 14px", fontSize: "12px", fontWeight: "bold", borderRadius: "20px" }}>
                          <i className="bi bi-shield-check me-1"></i> LIVE GATEWAY ACTIVE
                        </span>
                      ) : (
                        <span className="badge" style={{ background: "#e67e22", color: "#fff", padding: "8px 14px", fontSize: "12px", fontWeight: "bold", borderRadius: "20px" }}>
                          <i className="bi bi-shield-exclamation me-1"></i> TEST / SANDBOX MODE
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <label style={{ fontWeight: "700", color: "#4a1520", fontSize: "13px", display: "block", marginBottom: "6px" }}>
                        Razorpay Key ID *
                      </label>
                      <input
                        type="text"
                        style={{ width: "100%", height: "42px", padding: "8px 12px", borderRadius: "8px", border: "1.5px solid #5d1d2b", fontFamily: "monospace", fontSize: "13px", fontWeight: "bold", color: "#111", background: "#fff" }}
                        placeholder="e.g. rzp_live_xxxxxxxxxxxx or rzp_test_xxxxxxxxxxxx"
                        value={paymentSettings.razorpay_key_id || ""}
                        onChange={(e) => {
                          const val = e.target.value.trim();
                          const autoMode = val.startsWith("rzp_live") ? "live" : "test";
                          setPaymentSettings({ ...paymentSettings, razorpay_key_id: val, razorpay_mode: autoMode });
                        }}
                        required
                      />
                      <small className="text-muted d-block mt-1" style={{ fontSize: "11px" }}>
                        Key ID from Razorpay Dashboard (supports both <code>rzp_live_</code> and <code>rzp_test_</code>)
                      </small>
                    </div>

                    <div className="col-md-6">
                      <label style={{ fontWeight: "700", color: "#4a1520", fontSize: "13px", display: "block", marginBottom: "6px" }}>
                        Razorpay Key Secret *
                      </label>
                      <div className="position-relative" style={{ position: "relative" }}>
                        <input
                          type={showRazorpaySecret ? "text" : "password"}
                          style={{ width: "100%", height: "42px", padding: "8px 40px 8px 12px", borderRadius: "8px", border: "1.5px solid #5d1d2b", fontFamily: "monospace", fontSize: "13px", color: "#111", background: "#fff" }}
                          placeholder="Razorpay Key Secret"
                          value={paymentSettings.razorpay_key_secret || ""}
                          onChange={(e) => setPaymentSettings({ ...paymentSettings, razorpay_key_secret: e.target.value.trim() })}
                          required
                        />
                        <span
                          role="button"
                          onClick={() => setShowRazorpaySecret(!showRazorpaySecret)}
                          style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#666", fontSize: "16px", userSelect: "none" }}
                          title={showRazorpaySecret ? "Hide Secret" : "Show Secret"}
                        >
                          <i className={`bi bi-${showRazorpaySecret ? "eye-slash-fill" : "eye-fill"}`}></i>
                        </span>
                      </div>
                      <small className="text-muted d-block mt-1" style={{ fontSize: "11px" }}>
                        Confidential Secret from Razorpay Dashboard API Keys section
                      </small>
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "#5d1d2b",
                    color: "#fff",
                    padding: "12px 30px",
                    fontWeight: "bold",
                    borderRadius: "6px",
                    cursor: "pointer",
                    border: "none",
                    width: "100%"
                  }}
                  disabled={savingSettings}
                >
                  {savingSettings ? "Saving Settings..." : "Save Payment & Form Settings"}
                </button>
              </form>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AdminForms;
